import { createReducer, on } from '@ngrx/store';
import * as Action from '../actions/form-info.action';

export type initialStateType = {
    landData: any;
    condoData: any;
    buildingData: any;
    upload: any;
    isEmpty: boolean;
};

export const initialState: initialStateType = {
    landData: {},
    condoData: {},
    buildingData: {},
    upload: [],
    isEmpty: true,
};

const _FormInfoReducer = createReducer(
    initialState,
    on(Action.SetInfoLand, (state, action) => {
        return {
            ...state,
            landData: action.landData,
            isEmpty: false,
        };
    }),

    on(Action.SetInfoCondo, (state, action) => {
        return {
            ...state,
            condoData: action.condoData,
            isEmpty: false,
        };
    }),

    on(Action.SetInfoBuilding, (state, action) => {
        return {
            ...state,
            buildingData: action.buildingData,
            isEmpty: false,
        };
    }),
    on(Action.SetUpload, (state, action) => {
        return {
            ...state,
            upload: action.upload,
            isEmpty: false,
        };
    }),
    on(Action.ResetStore, () => {
        return {
            landData: {},
            condoData: {},
            buildingData: {},
            upload: [],
            isEmpty: true,
        };
    })
);

export function formInfoReducer(state, action) {
    return _FormInfoReducer(state, action);
}
